export default "__VITE_ASSET__B17_VhYf__"